import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FiFileText } from 'react-icons/fi';

function EvidencePackStrip({ data }) {
  const { t } = useTranslation();

  // Default items
  const defaultItems = [
    'Requirement Compliance Matrix',
    'Traceability Snapshot',
    'ATP/TP',
    'FAT Readiness Checklist',
    'Wiring/Test Reports',
    'As-Built Configuration Summary'
  ];

  // Get translated content
  const title = t('evidencePack.title', { defaultValue: 'Typical Evidence Pack' });
  const translatedChips = t('evidencePack.chips', { returnObjects: true });
  const label = t('evidencePack.label', { defaultValue: 'Typical Acceptance Evidence Pack (program dependent):' });
  const microLine = t('evidencePack.microLine', { defaultValue: 'Evidence is structured to support acceptance closure without exposing sensitive program details.' });

  const items = Array.isArray(translatedChips) ? translatedChips : (data?.items || defaultItems);

  return (
    <div 
      className="py-10 md:py-12" 
      style={{ backgroundColor: '#f8fafc' }}
      data-testid="evidence-pack-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="max-w-4xl mx-auto text-center"
        >
          {/* Label with icon */}
          <div className="flex items-center justify-center gap-2 mb-4">
            <FiFileText className="text-base" style={{ color: '#101957' }} />
            <p className="text-sm font-semibold" style={{ color: '#101957' }}>
              {label}
            </p>
          </div>
          
          {/* Chips - centered */}
          <div className="flex flex-wrap justify-center gap-2 mb-4">
            {items.map((item, index) => (
              <span 
                key={index}
                className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium"
                style={{ 
                  backgroundColor: 'rgba(16, 25, 87, 0.06)',
                  color: '#101957',
                  border: '1px solid rgba(16, 25, 87, 0.08)'
                }}
              >
                {item}
              </span>
            ))}
          </div>

          {/* Micro line */}
          <p className="text-xs" style={{ color: '#94a3b8' }}>
            {microLine}
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default EvidencePackStrip;
